import React, { useState, useRef } from "react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import logo from "../../../assets/img/SimpleRenovate.svg";

import { hitForgotPasswordApi } from "../../../Redux/Common/ForgotPasswordSlice";
import { hitVerifyForgotPasswordCodeApi } from "../../../Redux/Common/VerifyForgotPasswordCodeSlice";
import { hitUpdatePasswordForgotCodeApi } from "../../../Redux/Common/UpdatePasswordForgotSlice";
import { set } from "date-fns";

export default function Forgot() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("email");
  const [verificationCode, setVerificationCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [emailDisabled, setEmailDisabled] = useState(false);
  const [codeVerified, setCodeVerified] = useState(false);
  const [resetPasswordToken, setResetPasswordToken] = useState("");
  const inputsRef = useRef([]);
  const [showSendCodeButton, setShowSendCodeButton] = useState(true);
  const [showSendCodeButtonMessage, setShowSendCodeButtonMessage] = useState(false);


  const [showresendButton, setShowresendButton] = useState(false);

  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState(["", "", "", "", "", ""]);

  const handleCodeChange = (e, index) => {
    const value = e.target.value;

    if (/^[0-9]?$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      setVerificationCode(newCode.join(""));

      // move focus to next input if not last
      if (value && index < 5) {
        inputsRef.current[index + 1].focus();
      }
    }
  };



  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const sendVerificationCodeApi = async () => {
    const contact = activeTab === "email" ? email : phone;
    if (!contact) {
      showToast("Please enter your email", "error");
      return;
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(contact)) {
      showToast("Please enter a valid email address", "error");
      return;
    }
    else {
      const response = await dispatch(hitForgotPasswordApi({ email: contact, userType:1 }));
      //console.log("response", response);
      if (response.payload && response.payload.status === true) {
        setShowSendCodeButton(false);
        setShowSendCodeButtonMessage(true);
        showToast("Verification code sent successfully", "success");
        setShowresendButton(true);
      } else {
        showToast(response.error.message || "Failed to send verification code", "error");
      }
    };
  }


  const verifyCodeApi = async () => {
    const verificationCode = code.join("");
    const response = await dispatch(hitVerifyForgotPasswordCodeApi({ email: email, otp: verificationCode, userType: 1 }));
    if (response.payload && response.payload.status === true) {
      showToast("Code verified successfully, You can set new password now", "success");
      setCodeVerified(true);
      setEmailDisabled(true);
      setShowSendCodeButtonMessage(false);
      setResetPasswordToken(response.payload.data.resetPasswordToken);
      // Proceed to reset password step
    } else {
      showToast(response.error.message || "Invalid verification code", "error");
    }
  };


  const resetpasswordApi = async (newPassword) => {
    const response = await dispatch(hitUpdatePasswordForgotCodeApi({ resetPasswordToken: resetPasswordToken, email: email, password: newPassword, userType: 1 }));
    if (response.payload && response.payload.status === true) {
      showToast("Password reset successfully. Please login with your new password.", "success");
      navigate("/professional/login");
    } else {
      showToast(response.error.message || "Failed to reset password", "error");
    }
  };

  return (
    <div className="verification-form">
      {/* Logo */}
      <div className="login-form__logo mb-2">
        <img src={logo} alt="Logo" />
      </div>

      <p className="verification-form__subtitle">
        Reset your password
      </p>

      {/* Tabs */}
      {/* <div className="verification-form__tabs">
        <button
          className={activeTab === "email" ? "active" : ""}
          onClick={() => setActiveTab("email")}
        >
          Reset via Email
        </button>
        <button
          className={activeTab === "phone" ? "active" : ""}
          onClick={() => setActiveTab("phone")}
        >
          Reset via Phone
        </button>
      </div> */}

      {/* Card */}
      <div className="verification-form__card">
        <h4>Forgot Password</h4>
        <p>Enter your info below to receive a reset code</p>

        {activeTab === "email" && (
          <form>
            <label>Email Address *</label>
            <input
              type="email"
              disabled={emailDisabled}
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />


            {showSendCodeButton &&
              <button type="button" className="verify-btn" onClick={() => {
                sendVerificationCodeApi(); // hypothetical API call              
              }}>
                Send Code
              </button>
            }

            {showSendCodeButtonMessage &&
              <><div className="info-box">
                A reset code has been sent to <b>{email}</b>
              </div><label>Enter Reset Code</label><div className="code-inputs">
                  {code.map((digit, idx) => (
                    <input
                      key={idx}
                      type="text"
                      maxLength="1"
                      value={digit}
                      ref={(el) => (inputsRef.current[idx] = el)}
                      onChange={(e) => handleCodeChange(e, idx)}
                      onKeyDown={(e) => handleKeyDown(e, idx)}
                    // style={{ width: "40px", textAlign: "center", fontSize: "18px" }}
                    />
                  ))}
                </div>

                <button type="button" className="verify-btn" onClick={() => {
                  verifyCodeApi(); // hypothetical API call              
                }}>
                  Verify Code
                </button>
              </>
            }

            {codeVerified &&
              <><label>New Password *</label><input type="password" placeholder="Enter new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                <button type="button" className="verify-btn" onClick={() => {
                  resetpasswordApi(newPassword); // hypothetical API call              
                }}>
                  Reset Password
                </button></>
            }
          </form>
        )}

        {showresendButton &&
          <div className="resend">
            Didn’t receive code? <a href="#" onClick={() => {
              sendVerificationCodeApi();
            }} >Resend code</a>
          </div>
        }

        <p className="login-text">
          Remember your password? <a href="/professional/login">Login here</a>
        </p>
      </div>
    </div>
  );
}
